<template>
	<div class="home">
		<header class="home-top-bar">
			<div class="home-top-bar__spacer" aria-hidden="true" />
			<nav class="home-tabs" aria-label="首页主功能切换">
				<button
					type="button"
					class="home-tab"
					:class="{ 'home-tab--active': mainTab === 'insight' }"
					@click="mainTab = 'insight'"
				>
					品牌 & 市场洞察
				</button>
				<button
					type="button"
					class="home-tab"
					:class="{ 'home-tab--active': mainTab === 'materials' }"
					@click="mainTab = 'materials'"
				>
					营销素材
					<!-- <span
						class="home-tab__badge"
						:class="{ 'home-tab__badge--hidden': mainTab !== 'insight' }"
						aria-hidden="true"
					/> -->
				</button>
			</nav>
			<div class="home-top-bar__actions">
				<!-- 始终占位，避免 v-if 移除按钮后 grid 右列 min-width 变化、Tab 居中偏移 -->
				<button
					type="button"
					class="enter-btn"
					:class="{ 'enter-btn--hidden': mainTab !== 'insight' }"
					:tabindex="mainTab === 'insight' ? 0 : -1"
					@click="handleEnter"
				>
					进入JuJuLink
				</button>
			</div>
		</header>

		<div class="home-body">
			<BrandMarketInsightTab v-show="mainTab === 'insight'" />
			<MarketingMaterialsTab v-show="mainTab === 'materials'" />
		</div>
	</div>
</template>

<script>
import BrandMarketInsightTab from '@/views/home/BrandMarketInsightTab.vue';
import MarketingMaterialsTab from '@/views/home/MarketingMaterialsTab.vue';

export default {
	name: 'Home',
	components: {
		BrandMarketInsightTab,
		MarketingMaterialsTab
	},
	data() {
		return {
			mainTab: 'insight'
		};
	},
	methods: {
		handleEnter() {
			const isProduction = process.env.NODE_ENV === 'production';
			const targetUrl = isProduction
				? 'https://chat-orange.wuyuejuzi.com/'
				: 'https://chat-orange-dev.wuyuejuzi.com/';
			window.open(targetUrl, '_blank');
		}
	}
};
</script>

<style lang="scss" scoped>
.home {
	display: flex;
	flex-direction: column;
	height: 100vh;
	background: #f5f5f5;
	padding-bottom: 50px;
	box-sizing: border-box;
	/* 两 Tab 主内容区共用：左留白对齐固定侧栏；右侧为 fixed 聊天区宽度，主区 padding-right 为 30px + 该值（与左侧距边 30px 对称） */
	--home-layout-sidebar-inset: 420px;
	--home-layout-right-rail: 300px;
	--home-layout-main-max: 900px;
	--home-layout-main-pad-x: 24px;
	--home-layout-greeting-top: 70px;
}

.home-top-bar {
	display: grid;
	grid-template-columns: 1fr auto 1fr;
	align-items: center;
	padding: 16px 20px 0;
	flex-shrink: 0;
	gap: 12px;
}

.home-top-bar__spacer {
	min-width: 0;
}

.home-tabs {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 40px;
}

.home-tab {
	position: relative;
	padding: 8px 4px 12px;
	background: none;
	border: none;
	font-size: 16px;
	color: #999;
	cursor: pointer;
	font-weight: 500;
	transition: color 0.2s ease;
}

.home-tab::after {
	content: '';
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	height: 3px;
	border-radius: 2px;
	background: transparent;
	transition: background 0.2s ease;
}

.home-tab--active {
	color: #fdc408;
	/* 与未选中同字重，仅靠颜色与下划线区分，避免加粗导致字宽变化 */
	font-weight: 500;
}

.home-tab--active::after {
	background: #fdc408;
}

.home-tab__badge {
	display: inline-block;
	width: 6px;
	height: 6px;
	margin-left: 6px;
	vertical-align: super;
	border-radius: 50%;
	background: #e53935;
}

.home-tab__badge--hidden {
	visibility: hidden;
}

.home-top-bar__actions {
	display: flex;
	justify-content: flex-end;
	align-items: center;
}

.enter-btn {
	background: #2d2d2d;
	color: #fdc408;
	border: none;
	border-radius: 6px;
	padding: 8px 16px;
	font-size: 14px;
	font-weight: 700;
	cursor: pointer;
	transition: all 0.3s ease;
	white-space: nowrap;
}

.enter-btn:hover:not(.enter-btn--hidden) {
	background: #5a5a5a;
	transform: translateY(-1px);
}

.enter-btn--hidden {
	visibility: hidden;
	pointer-events: none;
}

.home-body {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
</style>
